import React, { FC, useCallback, useEffect } from 'react';
import styles from './TransferItemsForm.module.scss'
import { ITransferItemSelectable, ITransferItemsFormValue } from './TransferItemsForm';
import { Checkbox, FormControlLabel } from '@mui/material';
import { moneyMaskNumber } from '../../../../services/utils/Money';

interface CancelOrderFormItemProps {
    selectableOrder: ITransferItemsFormValue;
    onChange: (item: ITransferItemsFormValue, checked: boolean) => void;
    onChangeItem: (item: ITransferItemSelectable, checked: boolean) => void;
}

export const TransferItemsFormItem: FC<CancelOrderFormItemProps> = ({ selectableOrder, onChange, onChangeItem }) => {
    const [checked, setChecked] = React.useState(false);

    const onChangeItemHandle = useCallback((item: ITransferItemSelectable, checked: boolean) => {
        onChangeItem(item, checked);
    }, [onChangeItem]);

    const onChangeHandle = useCallback((event, checked: boolean) => {
        onChange(event, checked);
        setChecked(checked);
    }, [onChange]);


    useEffect(() => {
        if (selectableOrder.items.every(item => item.isChecked)) {
            setChecked(true)
        } else {
            setChecked(false)
        }
    }, [selectableOrder.items])


    return <div id={styles.TransferItemsFormItem}>
        <FormControlLabel
            disabled={selectableOrder.isCanceled || selectableOrder.isTransfered}
            checked={checked}
            onChange={(ev, checked) => onChangeHandle(selectableOrder, checked)}
            control={<Checkbox />}
            label={<div className={styles.header}>{new Date(selectableOrder.createdAt + "Z").toLocaleString()}</div>}
        />
        <div className={styles.itemList}>
            {selectableOrder.items.map(item => (
                <div key={item.id} className={styles.item}>
                    <FormControlLabel
                        disabled={selectableOrder.isCanceled || selectableOrder.isTransfered}
                        checked={item.isChecked}
                        onChange={(_, checked) => onChangeItemHandle(item, checked)}
                        control={<Checkbox />}

                        label={
                            <div className={styles.itemLabel}>
                                {item.quantity} - {item.name}
                            </div>
                        }
                    />
                    <span>{moneyMaskNumber(item.totalValue)}</span>
                </div>
            ))}
        </div>
    </div>;
};
